module.exports = __webpack_public_path__ + "static/media/ic_landline.503baf6d.png";